import { useMemo } from 'react'
import { IanaTimeZoneWithTheCurrentUtcOffset, useGetFilterTimezoneQuery } from '../../../../app/api'
import { IOption } from '../../../../shared/components/forms/search-input/BpSearchInput'

/** «+05:45» → «+5:45», «+00:00» → «+0»: формат подписи из спеки, Europe/Moscow (UTC+3) */
const shortOffset = (offset: string): string => {
  const match = offset.match(/^([+-])(\d{2}):(\d{2})$/)

  if (!match) return offset

  const [, sign, hours, minutes] = match

  return `${sign}${Number(hours)}${minutes === '00' ? '' : `:${minutes}`}`
}

const toLabel = ({ id, offset }: IanaTimeZoneWithTheCurrentUtcOffset) =>
  `${id} (UTC${shortOffset(offset)})`

/**
 * Часовые пояса из /filter/timezone: тот же список, которым бэк проверяет пояс при сохранении.
 * Основные зоны бэк отдаёт первыми, уже упорядоченными по смещению
 */
export const useTimezones = () => {
  const { data, isFetching } = useGetFilterTimezoneQuery()

  return useMemo(() => {
    const zones = data?.data ?? []
    const byId = new Map(zones.map((zone) => [zone.id, zone]))
    const toOption = (zone: IanaTimeZoneWithTheCurrentUtcOffset): IOption => ({
      value: zone.id,
      text: toLabel(zone),
    })

    return {
      loading: isFetching && !zones.length,
      all: zones.map(toOption),
      main: zones.filter(({ is_main }) => is_main).map(toOption),
      /** Подпись пояса со смещением; пока список не загружен — просто идентификатор */
      label: (id?: string | null): string => {
        if (!id) return ''

        const zone = byId.get(id)

        return zone ? toLabel(zone) : id
      },
    }
  }, [data, isFetching])
}
